import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  wrapper: {
    marginInline: "auto",
    left: ({ isNavbarOpen }) => (isNavbarOpen ? "7%" : "2%"),
    width: 800,
    backgroundColor: ({ theme }) => theme.palette.bgColor,
    borderRadius: "8px",
    position: 'relative',
    transition: 'left 0.4s',
  },
  textWrapper: {
    textAlign: "center",
    display: 'flex',
    flexDirection: 'column',
    gap: 15
  },
  text: {
    color: ({ theme }) => theme.palette.text.primary,
  },
  emptyStateWrapper: {
    minHeight: '680px',
    backgroundColor: ({ theme }) => theme.palette.themeColor,
    display: 'flex',
    alignItems: 'center',
  },
  homePageBtn: {
    color: "#FFFFFF",
    backgroundColor: "#B80351",
    "&:hover": {
      backgroundColor: "#B80351",
    },
    fontFamily: 'Rubik',
    textTransform: 'none'
  }
});
